import { useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertCircle, LogIn, ShieldCheck } from "lucide-react";
import { startGoogleLogin } from "@/lib/authApi";
import { ADMIN } from "@/constants/testIds/admin";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AdminLoginPage() {
    const [busy, setBusy] = useState(false);
    const location = useLocation();
    const refused = location.state?.refused;
    const refusedEmail = location.state?.email;

    return (
        <div
            data-testid={ADMIN.loginPage}
            className="min-h-screen bg-[#F8FAFC] grid place-items-center px-6 py-16"
        >
            <div className="max-w-md w-full bg-white border border-slate-200 p-8 md:p-10">
                <div className="flex items-center gap-3">
                    <span className="w-10 h-10 rounded-full bg-[#0F172A] text-white grid place-items-center">
                        <ShieldCheck size={18} strokeWidth={1.6} />
                    </span>
                    <div>
                        <span className="ihx-eyebrow">Clinic Admin</span>
                        <h1 className="font-serif text-[22px] mt-1 leading-tight">
                            Dr. Ishani Hanspal · Internal
                        </h1>
                    </div>
                </div>

                {refused && (
                    <div className="mt-6 p-4 border border-[#991B1B] bg-[#FEF2F2] flex items-start gap-3">
                        <AlertCircle
                            size={16}
                            strokeWidth={1.6}
                            className="text-[#991B1B] mt-[2px]"
                        />
                        <div className="text-[13px] leading-[1.6] text-[#991B1B]">
                            <div className="font-medium">Account not on the allow-list</div>
                            <div className="text-slate-700 mt-1">
                                {refusedEmail
                                    ? `${refusedEmail} isn’t authorised for the admin area.`
                                    : "This account isn’t authorised for the admin area."}
                                {" "}Please sign in with a clinic-approved Google account.
                            </div>
                        </div>
                    </div>
                )}

                <p className="ihx-lead mt-6 text-[14.5px]">
                    Sign in with the Google account on the practice’s allow-list to view
                    incoming Discovery Form submissions.
                </p>

                <button
                    type="button"
                    data-testid={ADMIN.googleLoginBtn}
                    disabled={busy}
                    onClick={() => {
                        setBusy(true);
                        startGoogleLogin();
                    }}
                    className="ihx-btn-primary w-full justify-center mt-8 disabled:opacity-60"
                >
                    <LogIn size={16} strokeWidth={1.7} />
                    {busy ? "Redirecting…" : "Sign in with Google"}
                </button>

                <p className="text-[11.5px] text-slate-500 leading-[1.7] mt-6">
                    This area is restricted to email addresses on the clinic’s allow-list.
                    All other accounts will be politely refused.
                </p>
            </div>
        </div>
    );
}
